import { useState } from 'react';
import axios from 'axios';
import { Mail, CheckCircle, Loader2 } from 'lucide-react';
import { Input } from './ui/input';
import { Button } from './ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TXT = {
  it: { link: 'Password dimenticata?', title: 'Recupero password', text: "Inserisca l'email del suo account: le invieremo un link per scegliere una nuova password (valido 1 ora).", send: 'Invia link', back: "Torna all'accesso", done: "Se l'indirizzo è registrato, riceverà a breve un'email con il link. Controlli anche la posta indesiderata.", error: 'Invio non riuscito. Riprovi tra poco.' },
  en: { link: 'Forgot password?', title: 'Password recovery', text: 'Enter your account email: we will send you a link to choose a new password (valid for 1 hour).', send: 'Send link', back: 'Back to login', done: 'If the address is registered, you will shortly receive an email with the link. Please also check your spam folder.', error: 'Sending failed. Please try again shortly.' },
  de: { link: 'Passwort vergessen?', title: 'Passwort wiederherstellen', text: 'Geben Sie die E-Mail Ihres Kontos ein: Wir senden Ihnen einen Link zum Festlegen eines neuen Passworts (1 Stunde gültig).', send: 'Link senden', back: 'Zurück zur Anmeldung', done: 'Falls die Adresse registriert ist, erhalten Sie in Kürze eine E-Mail mit dem Link. Prüfen Sie auch den Spam-Ordner.', error: 'Senden fehlgeschlagen. Bitte versuchen Sie es gleich erneut.' },
  fr: { link: 'Mot de passe oublié ?', title: 'Récupération du mot de passe', text: "Saisissez l'email de votre compte : nous vous enverrons un lien pour choisir un nouveau mot de passe (valable 1 heure).", send: 'Envoyer le lien', back: 'Retour à la connexion', done: "Si l'adresse est enregistrée, vous recevrez sous peu un email avec le lien. Vérifiez aussi vos spams.", error: "L'envoi a échoué. Réessayez dans un instant." },
};

export const ForgotPasswordLink = ({ lang, onOpen }) => (
  <button type="button" onClick={onOpen} className="block mx-auto text-xs text-[#283880] hover:text-[#C9A227] underline" data-testid="forgot-password-link">
    {(TXT[lang] || TXT.it).link}
  </button>
);

export const ForgotPasswordForm = ({ lang, initialEmail, onBack }) => {
  const t = TXT[lang] || TXT.it;
  const [email, setEmail] = useState(initialEmail || '');
  const [state, setState] = useState('idle');
  const submit = async (e) => {
    e.preventDefault();
    setState('busy');
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setState('done');
    } catch {
      setState('error');
    }
  };
  return (
    <div className="space-y-4" data-testid="forgot-password-form">
      <div>
        <p className="font-semibold text-[#283880]">{t.title}</p>
        <p className="text-sm text-slate-500 mt-1">{t.text}</p>
      </div>
      {state === 'done' ? (
        <p className="flex gap-2 text-sm text-green-700 bg-green-50 p-3 rounded-lg" data-testid="forgot-password-done"><CheckCircle className="w-4 h-4 shrink-0 mt-0.5" />{t.done}</p>
      ) : (
        <form onSubmit={submit} className="space-y-3">
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="pl-10" required data-testid="forgot-password-email" />
          </div>
          {state === 'error' && <p className="text-xs text-red-600" data-testid="forgot-password-error">{t.error}</p>}
          <Button type="submit" disabled={state === 'busy'} className="w-full bg-[#283880] hover:bg-[#1e2d66] text-white py-3" data-testid="forgot-password-submit">
            {state === 'busy' && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}{t.send}
          </Button>
        </form>
      )}
      <button type="button" onClick={onBack} className="block mx-auto text-xs text-slate-500 hover:text-[#283880] underline" data-testid="forgot-password-back">{t.back}</button>
    </div>
  );
};
